// extracted by mini-css-extract-plugin
export default {"loginForm":"login-form_loginForm__+WYBo","btnLogin":"login-form_btnLogin__c9UZK","forgetPwd":"login-form_forgetPwd__03PWV"};